import { render, staticRenderFns } from "./Ordenamiento.vue?vue&type=template&id=3e4049f0&"
import script from "./Ordenamiento.vue?vue&type=script&lang=js&"
export * from "./Ordenamiento.vue?vue&type=script&lang=js&"
import style0 from "./Ordenamiento.vue?vue&type=style&index=0&id=3e4049f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports